import { types, applySnapshot } from 'mobx-state-tree';
import Framework from '@greenville/framework';
import * as constants from '../../../common/constants';

const BookSearchModel = types.model('BookSearchModel', {
  id: types.maybeNull(types.string),
  identifierId: types.maybeNull(types.string),
  author: types.maybeNull(types.string),
  type: types.maybeNull(types.string),
  title: types.maybeNull(types.string),
  status: types.maybeNull(types.string),
  createdBy: types.maybeNull(types.string),
  courseId: types.maybeNull(types.string),
  manifestId: types.maybeNull(types.string),
  trackingId: types.maybeNull(types.string),
  updatedAt: types.maybeNull(types.string),
  graphId: types.maybeNull(types.string),
  name: types.maybeNull(types.string)
});

const McqSearch = types
  .model('McqSearch', {
    data: types.optional(types.array(BookSearchModel), []),
    lastPayload: types.optional(types.frozen(), {})
  })
  .actions((self) => ({
    setLastPayload(payload) {
      applySnapshot(self, { ...self, lastPayload: payload });
    },
    fetch(payload) {
      self.setLastPayload(payload);
      Framework.getEventManager().publish(constants.FETCH_MCQ_SEARCH_DATA, {
        payload
      });
    },
    setResponse(response) {
      const summary = response.data.map((item) => ({
        ...item,
        updatedAt: new Date(Number(item.updatedAt)).toLocaleString()
      }));
      applySnapshot(self.data, summary);
      Framework.getEventManager().publish(constants.SET_MCQ_SEARCH_DATA);
    },
    resetStoreValues() {
      const initialState = [];
      applySnapshot(self.data, initialState);
      Framework.getEventManager().publish(constants.SET_MCQ_SEARCH_DATA);
    }
  }));

export default McqSearch;
